module.exports = __webpack_public_path__ + "sj.svg?fb2733602a581b6b579249658ce48914";